import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CenterContent from '../Components/CenterContent/CenterContent'
import { teacher } from './../store/teacher'
import TeacherIntrument from '../block/TeacherInstument'
import { observer } from 'mobx-react-lite'
import http from '../Service/http'
import { toast } from 'react-toastify'
import { notify } from '../Utils/notify'

export default observer(function TeacherContainer() {
	const { t } = useTranslation()
	const [docList, setDocList] = useState([])


	useEffect(()=>{
		document.onclick = hideMenu
		getDocTeachList()
	},[])
	const getDocTeachList = async () => {
		const res = await http.get('/teacher/teacher-doc-list')

		const data = [].concat(res.data.data).sort((a, b) => (a.sort > b.sort ? 1 : -1))
		setDocList(data)
		console.log('docList', res.data)
	}

	const postInsertDocTeacher = async id_okno_document => {
		const res = await http.post('/teacher/insertDocTeach', {
			        id_teacher: teacher.teacher.id_teacher
				   , id_working:teacher.teacher.id_working 
				   , doc: id_okno_document
				   , year:teacher.teacher.id_a_year
		})
		toast('Заявка отправлена на исполнение')
		if (res.data.result === 'Заявка отправлена на исполнение') {
			notify('Заявка отправлена на исполнение')
		}
	}

	function hideMenu() {
		const contextMenu = document.getElementById('contextMenu')
		if (contextMenu) {
			contextMenu.style.display = 'none'
		}
	}

	function rightClick(e) {
		if (e.button === 2) {
		  const contextMenu = document.getElementById('contextMenu');
		  if (contextMenu) {
			e.preventDefault();
			const menuWidth = contextMenu.offsetWidth;
			const menuHeight = contextMenu.offsetHeight;
			const screenWidth = window.innerWidth;
			const screenHeight = window.innerHeight;
			let menuX = e.pageX + 10;
			let menuY = e.pageY - 40;
	  
			if (menuX + menuWidth > screenWidth) {
			  menuX = screenWidth - menuWidth;
			}
	  
			if (menuY + menuHeight > screenHeight) {
			  menuY = e.pageY - menuHeight;
			}
	  
			if (menuY < 0) {
			  menuY = e.pageY;
			}
	  
			contextMenu.style.display = 'block';
			contextMenu.style.left = menuX + 'px';
			contextMenu.style.top = menuY + 'px';
		  }
		}
	  }
	  
	  function leftClick(e) {
		const contextMenu = document.getElementById('contextMenu');
		if (contextMenu) {
		  contextMenu.style.display = 'none';
		}
	  }

	  function documentClick(id_okno_document) {
		console.log('documentClick')
		postInsertDocTeacher(id_okno_document)
		console.log('documentClick', id_okno_document)
		console.log('id_teacher', teacher.teacher.id_teacher)

	}
	  document.addEventListener('contextmenu', rightClick);
	  document.addEventListener('click', leftClick);

	return (
		<div>
			<CenterContent>
				<TeacherIntrument />
				<div id='contextMenu' className='context-menu' style={{ display: 'none' }}>
				<ul className='menu'>
					{docList?.length &&
						docList.map((doc, index) => (
							<li className='share' key={doc.id_okno_document} onClick={() => documentClick(doc.id_okno_document)}>
								<a>
									<i className='fa fa-copy' aria-hidden='true'></i> {doc.okno_document}
								</a>
							</li>
						))}
					
				</ul>
			</div>
				<div className='TableWrapper'>
					<table>
						<thead>
							<tr>
								<th style={{ width: '5%' }}>№</th>
								<th style={{ width: '45%', textAlign: 'left' }}>{t('st:table.fio')}</th>
								<th style={{ width: '20%', textAlign: 'left' }}>{t('st:appTitle.titles.jobTitle')}</th>

							</tr>
						</thead>
						<tbody>
							{teacher.teachers.map((item, index) => {
								if (item.id_teacher == teacher.teacher.id_teacher && item.post == teacher.teacher.post) {
									return (
										<tr
											key={index}
											className='active_line'
											onClick={() => {
												teacher.newTeacher(item)
											}}
											onContextMenu={e => {
												teacher.newTeacher(item)
												e.preventDefault()
												leftClick(e, item)
												rightClick(e, item)
											}}
										>
											<td>{index + 1}</td>
											<td style={{ textAlign: 'left' }}>{item.t_fio}</td>
											<td style={{ textAlign: 'left' }}>{item.post}</td>
											
										</tr>
									)
								}
								return (
									<tr
										key={index}
										onClick={() => {
											teacher.newTeacher(item)
										}}
										onContextMenu={e => {
											teacher.newTeacher(item)
											e.preventDefault()
											leftClick(e, item)
											rightClick(e, item)
										}}
									>
										<td>{index + 1}</td>
										<td style={{ textAlign: 'left' }}>{item.t_fio}</td>
										<td style={{ textAlign: 'left' }}>{item.post}</td>

									</tr>
								)
							})}
						</tbody>
					</table>
				</div>
			</CenterContent>
		</div>
	)
})
